import { Card, Flex, Layout, Typography } from 'antd';

import { css } from '@emotion/css';

export const KYCSuccessPage = () => {
  const layoutStyles = css`
    height: 100%;
  `;

  const contentStyles = css`
    padding: 16px;
  `;

  const headerStyles = css`
    margin-top: 0;
  `;

  const cardStyles = css`
    max-width: 460px;
  `;

  return (
    <Layout className={layoutStyles}>
      <Layout.Content className={contentStyles}>
        <Flex justify="center">
          <Card className={cardStyles}>
            <Flex vertical={true} gap={'middle'}>
              <Typography.Title className={headerStyles} level={3}>
                Information Submitted 🎉
              </Typography.Title>
              <Typography.Text>Your information has been successfully submitted for review.</Typography.Text>
              <Typography.Text type="success">You may now close this window.</Typography.Text>
            </Flex>
          </Card>
        </Flex>
      </Layout.Content>
    </Layout>
  );
};
